module.exports = __webpack_public_path__ + "img/screenshot_320_w.1fdb0b7f.jpg";